import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope, faLocationDot } from '@fortawesome/free-solid-svg-icons';

import './Footer.scss';

const Footer = () => {


  return (
    <>
      <footer className="footer">
        <div className="footer-contacts">

          <a href="mailto:sales@generalconcretegroup.com" className="phone">
            <FontAwesomeIcon className="phone-icon" icon={faEnvelope} />
            <span className="phone-text">sales@generalconcretegroup.com</span>
          </a>

          <a
            href="https://goo.gl/maps/dgjceaiJtDda2Dpp8"
            className="phone"
            rel="noreferrer"
            target="_blank"
          >
            <FontAwesomeIcon className="phone-icon" icon={faLocationDot} />
            <span className="phone-text">119-507 King St East, Toronto ON M5A1M3</span>
          </a>

          <a href="tel:+1 647 991 4682" className="phone">
            <FontAwesomeIcon className="phone-icon" icon={faPhone} />
            <span className="phone-text">+1 647 991 4682</span>
          </a>

        </div>
        <div className="footer-info">
          <p className="info-text">
            &#169; General Concrete Group Inc. 2025
          </p>
          <p className="info-text">
            All Rights Reserved.
          </p>
        </div>
      </footer>
    </>
  );
};

export default Footer;